import { takeLatest, call, put } from 'redux-saga/effects';
import { postPatientPhysicianSuccess, postPatientPhysicianFailure, putPatientPhysicianSuccess, putPatientPhysicianFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
function* postPatientPhysicianRequest(action) {
    try {
const response = yield call(apiPost, 'api/post-patient-physician', action.payload);
        yield put(postPatientPhysicianSuccess(response));
    } catch (error) {
        yield put(postPatientPhysicianFailure(error?.response?.message || error));
    }
}


function* putPatientPhysicianRequest(action) {
    try {
const response = yield call(apiPut, `api/edit-patient-physician/${action.payload._id}`, action.payload);
        yield put(putPatientPhysicianSuccess(response));
    } catch (error) {
        yield put(putPatientPhysicianFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientPhysician/postPatientPhysicianRequest', postPatientPhysicianRequest);
    yield takeLatest('patientPhysician/putPatientPhysicianRequest', putPatientPhysicianRequest);
}

export default saga;